import { get, deleteRequest, post } from 'helpers/api';

const getCallUrl = callId => `/click_to_call/calls/${callId}`;

export const getCall = callId => (
  get(getCallUrl(callId)).then(data => data.call)
);

export const startCall = (name, phone) => (
  post('/click_to_call/calls', { name, phone })
);

export const startPreviewCall = (name, phone) => (
  post('/click_to_call/calls', { name, phone, preview: true })
);

export const endCall = callId => (
  deleteRequest(getCallUrl(callId))
);

export default {
  endCall,
  getCall,
  startCall,
  startPreviewCall
};
